import React from 'react';

import ServicesNewsForm from './services-news-form';
import ServicesPressReleaseForm from './services-pressrelease-form';
import ServicesPhotosForm from './services-photos-form';
import ServicesPremiumVideoForm from './services-premium-video';
import ServicesEltaSenseForm from './services-elta-sense';

function ServicesTabComponent() {
  return (
    <>
      <ServicesPressReleaseForm />
      <ServicesNewsForm />
      <ServicesPhotosForm />
      <ServicesPremiumVideoForm />
      <ServicesEltaSenseForm />
    </>
  );
}

export default ServicesTabComponent;
